module.exports = __webpack_public_path__ + "img/icon_my_setup.4160720e.png";